(function () {
	try {
		// ==================== Initialization ====================
		const script = document.currentScript;
		const prev = script && script.previousElementSibling;
		const productInfo = (prev && prev.matches && prev.matches('safe-sticky.product-info'))
			? prev
			: document.querySelector('safe-sticky.product-info');

		if (!productInfo || productInfo.dataset.variantTitleObserverInitialized === 'true') return;
		productInfo.dataset.variantTitleObserverInitialized = 'true';

		// ==================== Variant Title Module ====================
		const VariantTitleManager = {
			titleEl: productInfo.querySelector('.product-title'),

			getNameOptionEl() {
				return productInfo.querySelector('.name-option .name-variant')
					|| productInfo.querySelector('.name-option');
			},

			sanitizeText(raw) {
				if (!raw) return '';
				// Remove colons and surrounding spaces, collapse multiple spaces
				return raw.replace(/\s*:\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();
			},

			updateVariantTitle() {
				if (!this.titleEl) return;

				const el = this.getNameOptionEl();
				const raw = el ? (el.textContent || '').trim() : '';
				const text = this.sanitizeText(raw);

				let span = this.titleEl.querySelector('.product-title__variant');

				if (text) {
					if (!span) {
						span = document.createElement('span');
						span.className = 'product-title__variant';
						this.titleEl.appendChild(span);
					}
					const display = ' In ' + text;
					if (span.textContent !== display) {
						span.textContent = display;
					}
				} else if (span) {
					span.textContent = '';
				}
			},

			observeChanges(target) {
				if (!target) return;

				const obs = new MutationObserver(() => this.updateVariantTitle());
				obs.observe(target, {
					childList: true,
					subtree: true,
					characterData: true,
					attributes: true
				});
				productInfo._variantTitleValueObserver = obs;
			},

			findAndWatch() {
				const el = this.getNameOptionEl();
				if (el) {
					this.updateVariantTitle();
					this.observeChanges(el.closest('.name-option') || el);
					return true;
				}
				return false;
			},

			init() {
				if (!this.findAndWatch()) {
					// Wait for the element within product info
					const localObs = new MutationObserver(() => {
						if (this.findAndWatch()) localObs.disconnect();
					});
					localObs.observe(productInfo, {childList: true, subtree: true});

					// Fallback: watch body in case element renders outside
					const bodyObs = new MutationObserver(() => {
						if (this.findAndWatch()) bodyObs.disconnect();
					});
					bodyObs.observe(document.body, {childList: true, subtree: true});
				}
			}
		};

		// ==================== Size Guide Module ====================
		const SizeGuideManager = {
			drawer: document.querySelector('.size-guide-drawer'),
			mainContainer: document.querySelector('#main'),

			init() {
				this.moveDrawerToMain();
				this.setupDrawerControls();
				this.ensureLink();
				this.setupSwatchListener();
			},

			moveDrawerToMain() {
				if (this.drawer && this.mainContainer) {
					this.mainContainer.appendChild(this.drawer);
				}
			},

			open() {
				if (!this.drawer) return;

				this.drawer.classList.add('is-open');
				this.drawer.setAttribute('aria-hidden', 'false');

				try {
					document.body.dataset.prevOverflow = document.body.style.overflow || '';
					document.body.style.overflow = 'hidden';
				} catch (e) {
					// Silent fail
				}
			},

			close() {
				if (!this.drawer) return;

				this.drawer.classList.remove('is-open');
				this.drawer.setAttribute('aria-hidden', 'true');

				try {
					document.body.style.overflow = document.body.dataset.prevOverflow || '';
					delete document.body.dataset.prevOverflow;
				} catch (e) {
					// Silent fail
				}
			},

			setupDrawerControls() {
				if (!this.drawer) return;

				const overlay = this.drawer.querySelector('.size-guide-overlay');
				const closeBtn = this.drawer.querySelector('.size-guide-close');

				overlay && overlay.addEventListener('click', () => this.close());
				closeBtn && closeBtn.addEventListener('click', () => this.close());

				document.addEventListener('keydown', (ev) => {
					if (ev.key === 'Escape') this.close();
				});
			},

			findRingSizeLegend() {
				let legend = productInfo.querySelector('legend.name-option[data-name="Ring size"]')
					|| document.querySelector('legend.name-option[data-name="Ring size"]');

				if (!legend) {
					const legends = Array.from((productInfo || document).querySelectorAll('legend.name-option'));
					legend = legends.find(l => ((l.getAttribute('data-name') || '').trim().toLowerCase() === 'ring size'))
						|| document.querySelector('.swatch--gl[data-option-index="1"] legend.name-option');
				}

				return legend;
			},

			createLink() {
				const link = document.createElement('a');
				link.href = '#';
				link.className = 'size-guide-link';
				link.textContent = 'Size Guide';
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.open();
				});
				return link;
			},

			ensureLink() {
				if (!this.drawer) return false;

				const legend = this.findRingSizeLegend();
				let existingLink = document.querySelector('.size-guide-link');

				// Fallback: place before buy buttons if legend not ready
				if (!legend) {
					const buyButtons = document.querySelector('[data-block-type="buy-buttons"]');
					if (buyButtons && !existingLink) {
						existingLink = this.createLink();
						buyButtons.parentNode.insertBefore(existingLink, buyButtons);
					}
					return false; // Still waiting for legend
				}

				// Move link to legend
				if (!existingLink) {
					existingLink = this.createLink();
				} else if (existingLink.parentNode !== legend) {
					// Detach if in wrong place
					existingLink.parentNode.removeChild(existingLink);
				}

				// Append only if not already inside legend
				if (!legend.contains(existingLink)) {
					legend.appendChild(document.createTextNode(' '));
					legend.appendChild(existingLink);
				}

				return true; // Success
			},

			watchForLegend() {
				const sgObs = new MutationObserver(() => {
					if (this.ensureLink()) {
						sgObs.disconnect();
					}
				});
				sgObs.observe(productInfo, {childList: true, subtree: true});
			},

			setupSwatchListener() {
				productInfo.addEventListener('click', (e) => {
					const swatchAnchor = (e.target && e.target.closest)
						? e.target.closest('.swatch-anchor')
						: null;

					if (swatchAnchor) {
						setTimeout(() => {
							VariantTitleManager.updateVariantTitle();
							this.ensureLink();
						}, 0);
					}
				});
			}
		};

		// ==================== Ring Size Selection Guard ====================
		const RingSizeSelectionManager = {
			legend: null,
			container: null,
			nameVariantEl: null,
			userSelected: false,
			init() {
				this.legend = (SizeGuideManager && SizeGuideManager.findRingSizeLegend) ? SizeGuideManager.findRingSizeLegend() : null;
				if (!this.legend) {
					this.watchForLegend();
					return;
				}
				this.setup();
			},
			watchForLegend() {
				const obs = new MutationObserver(() => {
					this.legend = (SizeGuideManager && SizeGuideManager.findRingSizeLegend) ? SizeGuideManager.findRingSizeLegend() : null;
					if (this.legend) {
						obs.disconnect();
						this.setup();
					}
				});
				obs.observe(productInfo, { childList: true, subtree: true });
			},
			setup() {
				this.container = this.legend.closest('.swatch--gl') || this.legend.parentElement;
				this.nameVariantEl = this.legend.querySelector('.name-variant');
				if (!this.nameVariantEl) {
					this.nameVariantEl = document.createElement('span');
					this.nameVariantEl.className = 'name-variant';
					this.legend.appendChild(document.createTextNode(' '));
					this.legend.appendChild(this.nameVariantEl);
				}
				this.applyInitialWarning();
				this.bindEvents();
				this.attachSubmitHandlers();
				this.attachFormGuard();
				this.observeNewButtons();
			},
			applyInitialWarning() {
				try {
					// Hide name-variant until user attempts to add to cart
					this.nameVariantEl.textContent = '';
					this.nameVariantEl.classList.remove('warning');
					this.nameVariantEl.style.display = 'none';
					// Reset dropdown UI to placeholder and clear selection
					this.resetDropdownToPlaceholder();
					setTimeout(() => this.resetDropdownToPlaceholder(), 0);
					this.disableBuyButtons();
				} catch (e) {}
			},
			getSubmitButtons() {
				const set = new Set();
				try {
					const inInfo = productInfo.querySelectorAll('.buy-buttons button[type="submit"]');
					inInfo && inInfo.forEach && inInfo.forEach(b => set.add(b));
				} catch (e) {}
				try {
					const sticky = document.querySelectorAll('.product-sticky-bar .buy-buttons button[type="submit"]');
					sticky && sticky.forEach && sticky.forEach(b => set.add(b));
				} catch (e) {}
				return Array.from(set);
			},
			setButtonText(btn, text) {
				if (!btn) return;
				try {
					// In this theme ATC buttons render plain text (no icon) for buy buttons; safe to set textContent
					btn.textContent = text;
				} catch (e) {}
			},
			setAllButtonsText(text) {
				this.getSubmitButtons().forEach(btn => this.setButtonText(btn, text));
			},
			scrollToVariantSelector() {
				try {
					const target = this.container || this.legend;
					if (!target) return;
					if (typeof target.scrollIntoView === 'function') {
						target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
					} else {
						const top = target.getBoundingClientRect().top + window.pageYOffset;
						window.scrollTo({ top, behavior: 'smooth' });
					}
				} catch (e) {}
			},
			disableBuyButtons() {
				// Do not hard-disable to allow click handler to show a message. Use aria-disabled + class and intercept submit.
				this.getSubmitButtons().forEach(btn => {
					if (btn.dataset.ringSizeGuard !== 'true') btn.dataset.ringSizeGuard = 'true';
					btn.setAttribute('aria-disabled', 'true');
					btn.classList.add('is-disabled');
				});
			},
			enableBuyButtons() {
				this.getSubmitButtons().forEach(btn => {
					if (btn.dataset.ringSizeGuard === 'true') {
						btn.removeAttribute('aria-disabled');
						btn.classList.remove('is-disabled');
					}
					this.setButtonText(btn, 'Add to Bag');
				});
			},
			resetDropdownToPlaceholder() {
				try {
					const c = this.container;
					if (!c) return;
					// Uncheck any selected radios
					c.querySelectorAll('input[type="radio"]').forEach(inp => {
						if (inp.checked) inp.checked = false;
						inp.removeAttribute && inp.removeAttribute('checked');
					});
					// Remove common selection classes
					c.querySelectorAll('.selected, .active, .is-selected').forEach(el => {
						el.classList.remove('selected');
						el.classList.remove('active');
						el.classList.remove('is-selected');
					});
					// Update dropdown visible text to placeholder
					const display = c.querySelector('.dropdown-button-gsw__value');
					if (display) display.textContent = 'Select Size';
				} catch (e) {}
			},
			bindEvents() {
				if (!this.container) return;
				const onChange = () => {
					setTimeout(() => this.handleSelectionChange(), 0);
				};
				this.container.addEventListener('change', onChange);
				this.container.addEventListener('click', (e) => {
					if (e.target && e.target.closest && e.target.closest('.swatch-anchor')) onChange();
				});
			},
			attachSubmitHandlers() {
				this.getSubmitButtons().forEach(btn => {
					if (btn.dataset.rsGuardClickBound === 'true') return;
					btn.dataset.rsGuardClickBound = 'true';
					btn.addEventListener('click', (ev) => {
						if (!this.userSelected) {
							ev.preventDefault();
							ev.stopPropagation();
							// Show inline warning only on attempt
							this.nameVariantEl.textContent = 'Please select a size';
							this.nameVariantEl.classList.add('warning');
							this.nameVariantEl.style.display = '';
							this.setButtonText(btn, 'Please select a size');
							if (btn.closest && btn.closest('.product-sticky-bar')) {
								this.scrollToVariantSelector();
							}
							return false;
						}
					});
				});
			},
			attachFormGuard() {
				const forms = [];
				try {
					const mainForm = productInfo.querySelector('product-form form');
					if (mainForm) forms.push(mainForm);
				} catch (e) {}
				try {
					document.querySelectorAll('.product-sticky-bar product-form form').forEach(f => forms.push(f));
				} catch (e) {}
				forms.forEach(form => {
					if (!form || form.dataset.rsGuardSubmitBound === 'true') return;
					form.dataset.rsGuardSubmitBound = 'true';
					form.addEventListener('submit', (ev) => {
						if (!this.userSelected) {
							ev.preventDefault();
							ev.stopPropagation();
							// Show inline warning only on attempt
							this.nameVariantEl.textContent = 'Please select a size';
							this.nameVariantEl.classList.add('warning');
							this.nameVariantEl.style.display = '';
							this.setAllButtonsText('Please select a size');
							if (form.closest && form.closest('.product-sticky-bar')) {
								this.scrollToVariantSelector();
							}
							return false;
						}
					});
				});
			},
			observeNewButtons() {
				if (this._buttonsObserver) return;
				try {
					const obs = new MutationObserver(() => {
						this.attachSubmitHandlers();
						this.attachFormGuard();
					});
					obs.observe(document.body, { childList: true, subtree: true });
					this._buttonsObserver = obs;
				} catch (e) {}
			},
			getSelectedValue() {
				const checked = this.container && this.container.querySelector('input[type="radio"]:checked');
				if (checked && typeof checked.value === 'string') return checked.value.trim();
				return '';
			},
			handleSelectionChange() {
				const val = this.getSelectedValue();
				if (val) {
					this.userSelected = true;
					this.nameVariantEl.textContent = val;
					this.nameVariantEl.classList.remove('warning');
					this.nameVariantEl.style.display = '';
					this.enableBuyButtons();
				}
			}
		};

		// ==================== Run Initialization ====================
		VariantTitleManager.init();
		SizeGuideManager.init();
		RingSizeSelectionManager.init();

		// Watch for size guide link placement
		if (!SizeGuideManager.ensureLink()) {
			SizeGuideManager.watchForLegend();
		}

		// Initial variant title update
		VariantTitleManager.updateVariantTitle();

	} catch (e) {
		// Silent fail - prevent breaking the page
	}
})();